<template>
  <el-form-item class="me-field" :class="{ 'me-field--edit': editable }">
    <span slot="label" class="me-field__label"><slot name="label">{{ label }}</slot></span>
    <slot v-if="editable"></slot>
    <div v-else class="me-field__value">{{ display }}</div>
  </el-form-item>
</template>
<script>
// Campo do modal de etiqueta: só leitura vira texto simples (sem caixa, sem sublinhado);
// editável mostra o input do slot. Vazio fica vazio, sem marcador.
export default {
  name: "PrePostField",
  props: {
    label: { type: String, default: "" },
    value: { type: [String, Number], default: "" },
    editable: { type: Boolean, default: false },
  },
  computed: {
    display() {
      return this.value === null || this.value === undefined ? "" : this.value;
    },
  },
};
</script>
<style scoped>
.me-field__value {
  min-height: 24px;
  line-height: 24px;
  font-size: 13px;
  color: #303133;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
